import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-stone-50 text-emerald-950" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjgannkimdn9" />
      <main data-id="element-2" data-mp="3rc9du70c5dx8">
        <Hero data-id="element-3" data-mp="3rcj846sey78q" />
        <SocialProof data-id="element-4" data-mp="3rbzomln47asl" />
        <Testimonials data-id="element-5" data-mp="3rdkl4gszp3t3" />
        <ProblemSection data-id="element-6" data-mp="3recedkz46pg7" />
        <SystemSection data-id="element-7" data-mp="5osn3wyp084" />
        <ModulesSection data-id="element-8" data-mp="6801qozk67w" />
        <BonusSection data-id="element-9" data-mp="5gfdawxfswe" />
        <UrgencySection data-id="element-10" data-mp="82ovg3doih9" />
        <PricingSection data-id="element-11" data-mp="2zld2jatxbhc2" />
        <MoreResults data-id="element-12" data-mp="2zm4ywnvchj3e" />
        <GuaranteeSection data-id="element-13" data-mp="2zmo5j8fjol24" />
        <FAQ data-id="element-14" data-mp="2zng2onosiqui" />
        <ClosingSection data-id="element-15" data-mp="33mf3bw3ho1g5" />
        <SummaryTable data-id="element-16" data-mp="33lx0uhq8gqzs" />
        <FinalCta data-id="element-17" data-mp="33n6yj5t6bx5w" />
      </main>
      <Footer data-id="element-18" data-mp="33oi0r16z0wuw" />
      <PurchaseNotification data-id="element-19" data-mp="38m1gk5jbhhoy" />
    </div>;
}